import {FetchOperation} from '../services/DataService';
import {showErrorMessage} from './PopupMessageHelpers';

export function handleFetchError(operation: FetchOperation, url: string,
                                 requestBody: any, statusCode: number,
                                 errorReason?: string) {
  if (statusCode < 500 || statusCode >= 599) {
    return;
  }

  showErrorMessage(false);

  throw new Error(
    `${operation} ${url} : [${statusCode}] ${errorReason || ''} - ${JSON.stringify(requestBody)}`
  );
}